<template>
    <div style="height: calc(100vh - 70px)">
        <el-row>
            <el-col :span="24">
                <div class="grid-content" style="padding-top: 20px;">
                    <!--<img v-if="group === 'EH'" class="common-img-icon" src="../../../assets/EHIS.png" style="width: 30%; display: block; margin: 0 auto"/>-->
                  <WithdrawalFormLogo :current-school="currentSchool" :isInternationalSchool="isInternationalSchool" />
                    <!--<img class="common-img-icon" src="../../../assets/MIS.svg"-->
                         <!--style="width: 30%; display: block; margin: 0 auto; height: 100px;"/>-->
                    <img src="../../../assets/tick.png" style="width: 100px"/>
                    <h3 class="success-text">Thank you for your submission. Our parent liaison team will get back to you
                        with a confirmation of your request shortly and the next steps in the withdrawal process.</h3>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import assets from "../../../assets/assets";
    import WithdrawalFormLogo from "@/pages/withdrawal/component/withdrawLogo.vue";

    export default {
        name: "WdfAfterSubmitMessage",
      components: { WithdrawalFormLogo },
        props: ["currentSchool","isInternationalSchool"],
        data(){
            return{
                assets: assets
            }
        }
    };
</script>